import * as React   from 'react';
import {connect}    from 'react-redux';
import Modal        from "react-responsive-modal";

const Loader = require('react-loader-spinner').default;


interface Props {
    onRef?: any;
    open?: boolean
}

interface State {
    isOpen: boolean;
}

class LoadingModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: !!props.open
        }
    }

    componentDidMount(): void {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }

    componentWillUnmount() {
        if (this.props.onRef) {
            this.props.onRef(undefined);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
        this.setState({isOpen: nextProps.open});
    }

    openModal = () => {
        this.setState({isOpen: true});
    };

    closeModal = () => {
        this.setState({isOpen: false});
    };

    render() {
        // tabIndex={1} on the loader-container prevents from pressing enter in the background
        return (
            <Modal
                center
                focusTrapped={true}
                open={this.state.isOpen}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 400,
                        boxShadow: "none",
                        paddingBottom: 0,
                        borderRadius: 5,
                        background: 'transparent'
                    }
                }}
                closeOnEsc={false}
                closeOnOverlayClick={false}
                onClose={this.closeModal}
            >
                <div id={'loader-container'} className={"container-fluid"} style={{width: 100, margin: 'auto', outline: 'none'}} tabIndex={1}>
                    <Loader
                        type="Oval"
                        color="#00BFFF"
                        height={100}
                        width={100}
                    />
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        open: ownProps.open
    }
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingModal)



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/LoadinModal.tsx